<template>
    <div class="box mt-5" v-if="accommodation">
        <div class="row">
            <div class="col-md-12 m-3">
                <h3> Accommodation: {{ accommodation.accommodation_name }} </h3>
            </div>
        </div>
      
        <div class="row">
            <div class="col-md-12">
            <Errors/>
            <form class="form" v-on:submit.prevent="updateAccommodation">
        
                <AccommodationFields/>
        
                <div class="form-wrap form-submit">
                <div v-if="this.getLoadStatus">
                    <button type="submit" class="button" disabled><span>Updating...</span></button>
                </div>
                <div v-else>
                    <button type="submit" class="button" v-if="userRole == 1"><span>Update accommodation</span></button>
                </div>
                </div>
        
            </form>
            </div>
        </div>
    </div>
</template>

<script>
import AccommodationFields from '@/components/AccommodationFields.vue'
import Errors from '@/components/Errors.vue'

import {mapGetters} from 'vuex'
export default {
    name: 'AccomodationDetails',
    components: {
        Errors,
        AccommodationFields
    },
    props: {
        accommodation:Object
    },
    computed: {
        ...mapGetters(['getLoadStatus']),
        userRole() {
        return localStorage.getItem("user_role");
        }
    },
    data() {
        return {
            showSection:true
        }
    },
    methods: {
        updateAccommodation () {
            this.$store.dispatch('setLoadStatus')
            fetch(this.$api + 'accommodation/' + this.$route.params.id, {
                method: 'POST',
                body: JSON.stringify(this.accommodation),
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Authorization': localStorage.getItem('token')
                }
            })
            .then(res => res.json())
            .then(response => {
                if(response.success) {
                    this.$notify({
                        type: 'success',
                        title: response.message
                    });
                } else if (response.errors) {
                    this.$notify({
                        type: 'error',
                        title: response.message
                    });
                }
                this.$store.dispatch('setLoadStatus')
            });
        }
    }        
}
</script>

<style lang="scss" scoped>

</style>